import { gql } from '@apollo/client';
import { apolloClient } from '../config/apollo-client';

// GraphQL mutation for updating a user
export const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser($updateUserInput: UpdateUserInput!) {
    updateUser(updateUserInput: $updateUserInput) {
      id
      username
      name
      email
      phone
      Balance {
        id
        amount
        credit
        onHold
      }
      credit
      isActive
      parentId
      comment
      lastLogin
      loginIp
      avatarUrl
      language
      timezone
      createdAt
      updatedAt
      isWagerEnabled
      isCashbackEnabled
      isOnlinePaymentEnabled
    }
  }
`;

// Types for updating users
export interface UpdateUserInput {
  id: number;
  isActive?: boolean;
  password?: string;
  name?: string;
  username?: string;
  email?: string;
  phone?: string;
  parentId?: number;
  comment?: string;
  avatarUrl?: string;
  language?: string;
  timezone?: string;
  isWagerEnabled?: boolean;
  isCashbackEnabled?: boolean;
  isOnlinePaymentEnabled?: boolean;
}

export interface UpdateUserResponse {
  id: number;
  username: string;
  name: string | null;
  email: string | null;
  phone: string | null;
  Balance: {
    id: number;
    amount: number;
    credit: number;
    onHold: number;
  } | null;
  credit: number;
  isActive: boolean;
  parentId: number | null;
  comment: string | null;
  lastLogin: string | null;
  loginIp: string | null;
  avatarUrl: string | null;
  language: string;
  timezone: string | null;
  createdAt: string;
  updatedAt: string;
  isWagerEnabled: boolean;
  isCashbackEnabled: boolean;
  isOnlinePaymentEnabled: boolean;
}

// UpdateUser service class
export class UpdateUserService {
  private static instance: UpdateUserService;

  private constructor() {}

  public static getInstance(): UpdateUserService {
    if (!UpdateUserService.instance) {
      UpdateUserService.instance = new UpdateUserService();
    }
    return UpdateUserService.instance;
  }

  async updateUser(
    updateUserInput: UpdateUserInput,
  ): Promise<UpdateUserResponse> {
    try {
      const { data } = await apolloClient.mutate({
        mutation: UPDATE_USER_MUTATION,
        variables: { updateUserInput },
      });
      return data.updateUser as UpdateUserResponse;
    } catch (error: any) {
      console.error('Error updating user:', error);
      if (error.graphQLErrors) {
        error.graphQLErrors.forEach((err: any) => {
          console.error('GraphQL Error:', err.message);
          console.error('Locations:', err.locations);
          console.error('Path:', err.path);
        });
      }
      if (error.networkError) {
        console.error('Network Error:', error.networkError);
      }
      throw error;
    }
  }
}

// Export singleton instance
export const updateUserService = UpdateUserService.getInstance();

// Export convenience function
export async function updateUser(
  updateUserInput: UpdateUserInput,
): Promise<UpdateUserResponse> {
  return updateUserService.updateUser(updateUserInput);
}
